import { render, staticRenderFns } from "./manually.vue?vue&type=template&id=22b7ff22"
import script from "./manually.vue?vue&type=script&lang=js"
export * from "./manually.vue?vue&type=script&lang=js"
import style0 from "./manually.vue?vue&type=style&index=0&id=22b7ff22&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports